import Badge, { BadgeBg } from 'components/base/Badge';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import React, { useState } from 'react';
import TemplateViewModal from './TemplateViewModal';
import { PitchDeck } from 'data/pitchdecks';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

const BoardViewItem = ({ pitchdeck }: { pitchdeck: PitchDeck }) => {
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  return (
    <>
      <RevealDropdownTrigger
        className="position-relative rounded-2 overflow-hidden p-4 cursor-pointer"
        style={{ height: 236 }}
        onClick={() => setOpenDetailsModal(true)}
      >
        <div
          className="bg-holder"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 39.41%, rgba(0, 0, 0, 0.4) 100%), url(${pitchdeck.thumbnail})`
          }}
        />
        <div className="position-relative h-100 d-flex flex-column justify-content-between">
          <div className="d-flex justify-content-between align-items-center">
            <Badge
              variant="phoenix"
              bg={pitchdeck.status?.displayType as BadgeBg}
              className="fs-10 light"
            >
              {pitchdeck.status?.label}
            </Badge>
            <div className="z-index-2">
              <RevealDropdown btnClassName="btn-icon" icon={faEllipsisV}>
                <ActionDropdownItems />
              </RevealDropdown>
            </div>
          </div>
          <h3 className="text-white light fw-bold line-clamp-2">
            {pitchdeck.title}
          </h3>
        </div>
      </RevealDropdownTrigger>

      <TemplateViewModal
        show={openDetailsModal}
        handleClose={() => setOpenDetailsModal(false)}
        pitchdeck={pitchdeck}
      />
    </>
  );
};

export default BoardViewItem;
